import React from 'react';
import { useTranslation } from 'react-i18next';

import { Popup } from 'src/components/Popup';
import s from './JobSurveyFalsification.styles';

export const SurveyUpdateWarningPopup = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Popup level={3} onClose={onClose} title={'Survey update warning'}>
      <s.Label>
        Changing status of this response will mean <b>re-cleaning</b> the
        previously uploaded data.
      </s.Label>
      <s.Label>Do you wish to continue?</s.Label>
      <s.PopupRow>
        <s.LinkButton ghost onClick={onClose} red sm type="button">
          {t('CANCEL')}
        </s.LinkButton>
        <s.ConfirmButton
          onClick={e => {
            e.preventDefault();
            onSubmit();
            onClose();
          }}
          orange
          sm
          solid
        >
          {t('YES')}
        </s.ConfirmButton>
      </s.PopupRow>
    </Popup>
  );
};
